
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/help",
      function () {
        return require("private-next-pages/[locale]/help/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/help"])
      });
    }
  